import { render, staticRenderFns } from "./DashboardsContainer.vue?vue&type=template&id=7665e2f7&lang=pug&"
import script from "./DashboardsContainer.vue?vue&type=script&lang=js&"
export * from "./DashboardsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports